{
    "Administrator": "Administrator:",
    "AdministratorRole": "Administrator Role:",
    "NAME": "AdministratorLanguage",
    "AdministratorLanguage_ServiceNotification": "Service Notification:",
    "AdministratorLanguage_ConcurrentSignins": "Concurrent Sign-Ins Permitted:"
}